import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  icon: '🛒',
  number: '01',
  title: 'Completa l’acquisto',
  description: 'Effettua un unico pagamento sicuro di 27 USD. Sono accettate le principali carte di credito e di debito.'
}, {
  icon: '📥',
  number: '02',
  title: 'Scarica immediatamente',
  description: 'Ricevi tramite e-mail l’accesso ai cinque volumi e ai quattro bonus. Nessuna attesa, nessuna applicazione obbligatoria e nessun abbonamento.'
}, {
  icon: '🖨️',
  number: '03',
  title: 'Scegli, stampa e insegna',
  description: 'Seleziona il materiale necessario per la tua prossima lezione, stampalo oppure utilizzalo in formato digitale. Più organizzazione, più chiarezza e meno tempo di preparazione.'
}];
export function HowItWorks() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-119" data-mp="14huoo2o8lcq0">
      <div className="mx-auto max-w-5xl" data-id="element-120" data-mp="19a49j4ahvmlf">
        <div className="mx-auto max-w-2xl text-center" data-id="element-121" data-mp="19byxkrh2butq">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-122" data-mp="2rkwauqgt5xj7">
            Come funziona
          </h2>
          <p className="mt-3 text-sm text-ink/70 sm:text-base" data-id="element-123" data-mp="2mki3zbqy0tmr">
            Semplice, immediato e pronto per la tua prossima lezione.
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-124" data-mp="2wjpr2qnhc2n2">
          {steps.map((step, i) => <React.Fragment key={step.number} data-id="element-125" data-mp="3aauij5gp1omb" data-mpi={i}>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.45,
            delay: i * 0.1
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-126" data-mp="36akevzgdjaam">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-cobalt/30 bg-white text-3xl" data-id="element-127" data-mp="1pxdhfd9gfnzp">
                  {step.icon}
                </span>
                <span className="mt-4 font-serif-display text-2xl font-bold text-cobalt" data-id="element-128" data-mp="3l00hp1frssel">
                  {step.number}
                </span>
                <h3 className="mt-2 text-lg font-bold text-ink" data-id="element-129" data-mp="3pyts2kzrg3aj">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-ink/70" data-id="element-130" data-mp="3tzdrjv7t3izu">
                  {step.description}
                </p>
              </motion.div>
              {i < steps.length - 1 && <div className="mx-auto h-8 w-px bg-cobalt/30 md:hidden" aria-hidden="true" data-id="element-131" data-mp="7sfein5elvco" />}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}